export const standardFieldKeys = {
  emailAddress: {
    key: 'EMAIL_ADDRESS',
  },
  fullName: {
    key: 'FULL_NAME',
  },
  phoneNumber: {
    key: 'PHONE_NUMBER',
  },
};

export const getLabel = ({ key, label, translate }) => {
  const standardField = standardFieldKeys[key];
  return standardField && translate
    ? translate(
        `INBOX_MGMT.PRE_CHAT_FORM.STANDARD_FIELDS.${standardField.key}.LABEL`
      )
    : label;
};
export const getPlaceHolder = ({ key, placeholder, translate }) => {
  const standardField = standardFieldKeys[key];
  return standardField && translate
    ? translate(
        `INBOX_MGMT.PRE_CHAT_FORM.STANDARD_FIELDS.${standardField.key}.PLACEHOLDER`
      )
    : placeholder;
};

export const getCustomFields = ({ standardFields, customAttributes }) => {
  let customFields = [];
  const { pre_chat_fields: preChatFields } = standardFields;
  customAttributes.forEach(attribute => {
    const itemExist = preChatFields.find(
      item => item.name === attribute.attribute_key
    );
    if (!itemExist) {
      customFields.push({
        label: attribute.attribute_display_name,
        placeholder: attribute.attribute_display_name,
        name: attribute.attribute_key,
        type: attribute.attribute_display_type,
        values: attribute.attribute_values,
        field_type: attribute.attribute_model,
        regex_pattern: attribute.regex_pattern,
        regex_cue: attribute.regex_cue,
        required: false,
        enabled: false,
      });
    }
  });
  return customFields;
};

export const getFormattedPreChatFields = ({ preChatFields, translate }) => {
  return preChatFields.map(item => {
    return {
      ...item,
      label: getLabel({
        key: item.name,
        label: item.label ? item.label : item.name,
        translate,
      }),
      placeholder: getPlaceHolder({
        key: item.name,
        placeholder: item.placeholder ? item.placeholder : item.name,
        translate,
      }),
    };
  });
};

export const getPreChatFields = ({
  preChatFormOptions = {},
  customAttributes = [],
  translate,
}) => {
  const { pre_chat_message, pre_chat_fields } = preChatFormOptions;
  let customFields = {};
  let preChatFields = {};

  const formattedPreChatFields = getFormattedPreChatFields({
    preChatFields: pre_chat_fields,
    translate,
  });

  customFields = getCustomFields({
    standardFields: { pre_chat_fields: formattedPreChatFields },
    customAttributes,
  });
  preChatFields = [...formattedPreChatFields, ...customFields];

  return {
    pre_chat_message,
    pre_chat_fields: preChatFields,
  };
};
